import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MenuComponent } from '../menu.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-menu-trigger',
  templateUrl: './menu-trigger.component.html',
  styleUrls: ['./menu-trigger.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, CommonModule, MatButtonModule, MatIconButton],
})
export class MenuTriggerComponent {
  @Input({ required: true }) isOn!: 'toolbar' | 'menu';
  @Input({ required: true }) mc!: MenuComponent;
  @Output() onclick: EventEmitter<any> = new EventEmitter<any>();
}
